import { ActionTypes } from "../../constants/action-types";

const initialState = {
    isAuthenticated: false,
    isLoading: false,
    signInDetails: [],
    signInError: [],
    signUpError: [],
    socialAuthError: [],
    forgetPassword: [],
    resetPassword: [],
    emailActivation: []
};

export const authenticationReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case ActionTypes.SIGNIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                signInDetails: payload,
                signInFail: [],
            };

        case ActionTypes.SIGNIN_FAIL:
            return {
                ...state,
                isAuthenticated: false,
                signInError: payload,
            };

        case ActionTypes.SIGNUP_FAIL:
            return {
                state,
                signUpError: payload,
            };

        case ActionTypes.SIGN_OUT:
            return {
                ...state,
                isAuthenticated: false,
                signInUser: payload,
                signInFail: [],
            };

        case ActionTypes.FORGET_PASSWORD:
            return {
                ...state,
                forgetPassword: payload,
            };

        case ActionTypes.RESET_PASSWORD:
            return {
                ...state,
                resetPassword: payload,
            };

        case ActionTypes.EMAIL_ACTIVATION:
            return {
                ...state,
                emailActivation: payload,
            };

        case ActionTypes.RESET_STORE:
            return {
                ...(state = initialState),
            };
        default:
            return state;
    }
};
